var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"text-center m-0 p-0"},[_vm._v(" International students, scholars, researchers, lecturers, teachers, au pairs, physicians and foreign professional employees – we’ve got you all covered! ")])}
var staticRenderFns = []

export { render, staticRenderFns }